import type { Country } from './Country';
import type { Role } from './Role';

export const defaultAddressKey = 'Default';

export interface UserAddress {
  id: number;
  user_id: number;
  name: string;
  country: Country;
  city: string;
  line1: string;
  line2: string | null;
  zipcode: string;
}

export interface UserPractitioner {
  name: string;
  surname: string;
  pivot: {
    patient_id: number;
    doctor_id: number;
  };
}

export interface User {
  id: number;
  name: string;
  surname: string;
  sex: string | null;
  email: string;
  birth: string | null;
  phone: string;
  role: Role;
  addresses: Array<UserAddress>;
  practitioners?: Array<UserPractitioner>;
  created_at?: string;
  updated_at?: string;
  restricted: number;
  can_use_discounts: number;
}
